import * as React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./Services/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
}
